import React from "react";
import { Box, Typography, Container } from "@mui/material";
import heroImage from "../assets/jossemange.jpg";
import { useTranslation } from "react-i18next";

export const Hero: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      id="hero"
      sx={{
        position: "relative",
        height: "100vh",
        width: "100%",
        overflow: "hidden",
        mt: "64px", // This accounts for the navbar height
      }}
    >
      {/* Background Image */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundImage: `url(${heroImage})`,
          backgroundPosition: "center",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          filter: "brightness(0.85)",
          zIndex: 1,
        }}
      />

      {/* Content Overlay */}
      <Container
        maxWidth="lg"
        sx={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          position: "relative",
          zIndex: 2,
          color: "rgba(255, 255, 255, 0.9)",
          textAlign: "center",
          px: { xs: 2, md: 3 },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontSize: { xs: "2.5rem", sm: "3.5rem", md: "6rem" },
            fontFamily: "'Great Vibes', cursive",
            mb: { xs: 2, md: 3 },
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
            letterSpacing: "0.02em",
            color: "white",
            lineHeight: { xs: 1.2, md: 1.1 },
          }}
        >
          {t("header.couple")}
        </Typography>
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: "1.5rem", sm: "2rem", md: "3rem" },
            fontFamily: "'Great Vibes', cursive",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
            letterSpacing: "0.02em",
            color: "white",
            lineHeight: { xs: 1.2, md: 1.1 },
          }}
        >
          {t("header.location")}
        </Typography>
      </Container>
    </Box>
  );
};
